import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=3c0244c9&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"
import style0 from "./Description.vue?vue&type=style&index=0&id=3c0244c9&prod&scoped=true&lang=css"
import style1 from "./Description.vue?vue&type=style&index=1&id=3c0244c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0244c9",
  null
  
)

export default component.exports